import React, {useEffect} from "react";
import "./LegalPages.css"; 

const LegalPages = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="legal-page">
      <div className="container">
        
        <h1>Privacy Policy</h1>
        <p><strong>Last updated: March 20, 2025</strong></p>

        <p>
          This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
        </p>
        <p>
          We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <h2>Interpretation and Definitions</h2>

        <h3>Interpretation</h3>
        <p>
          Words with capitalized first letters have meanings defined under the following conditions. These definitions apply regardless of singular or plural usage.
        </p>

        <h3>Definitions</h3>
        <ul>
          <li><strong>Account:</strong> A unique account created for You to access our Service.</li>
          <li><strong>Affiliate:</strong> An entity controlled by or under common control with Us.</li>
          <li><strong>Company:</strong> Moon AI ("We", "Us", "Our").</li>
          <li><strong>Cookies:</strong> Small files stored on Your device to enhance website functionality.</li>
          <li><strong>Country:</strong> India (Operating from Delhi, India).</li>
          <li><strong>Device:</strong> Any device that can access the Service (computer, mobile, tablet).</li>
          <li><strong>Service:</strong> The Moon AI website.</li>
          <li><strong>Usage Data:</strong> Data collected automatically, such as IP address, browser type, and interactions.</li>
          <li><strong>Website:</strong> Moon AI, accessible at <a href="https://moon-ai-one.vercel.app/" target="_blank">moon-ai-one.vercel.app</a></li>
        </ul>

        <h2>Collecting and Using Your Personal Data</h2>

        <h3>Types of Data Collected</h3>

        <h4>Personal Data</h4>
        <p>We collect the following data:</p>
        <ul>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Usage Data</li>
        </ul>

        <h4>Usage Data</h4>
        <p>Collected automatically when using the Service, including:</p>
        <ul>
          <li>IP address, browser type, device information</li>
          <li>Pages visited, time spent on pages</li>
          <li>Device identifiers and diagnostics</li>
        </ul>

        <h3>Tracking Technologies and Cookies</h3>
        <p>We use cookies and similar technologies to track activity on our Service. These include:</p>
        <ul>
          <li><strong>Essential Cookies:</strong> Necessary for website functionality.</li>
          <li><strong>Acceptance Cookies:</strong> Identify if users have accepted cookies.</li>
          <li><strong>Functionality Cookies:</strong> Remember login details and preferences.</li>
        </ul>

        <h2>Use of Your Personal Data</h2>
        <p>We use your data for:</p>
        <ul>
          <li>Providing and maintaining the Service</li>
          <li>Managing Your Account</li>
          <li>Customer support and security updates</li>
          <li>Business transfers (e.g., mergers, acquisitions)</li>
          <li>Marketing communications (if opted-in)</li>
        </ul>

        <h2>Retention & Security of Data</h2>
        <p>
          We retain data as long as necessary for legal and service-related reasons. Security measures are in place, but no system is 100% secure.
        </p>

        <h2>Data Transfers & Deletion Requests</h2>
        <p>
          Your data may be transferred across different locations for processing. You can request deletion of personal data by contacting us.
        </p>

        <h2>Children’s Privacy</h2>
        <p>Our Service is not intended for individuals under 13. If we discover underage data collection, we will remove it immediately.</p>

        <h2>Links to Third-Party Sites</h2>
        <p>We may link to external websites. We do not control or take responsibility for their policies.</p>

        <h2>Changes to this Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. The latest version will always be available on our website.</p>

        <hr />

        <h1>Terms of Service</h1>
        <p>By using Moon AI, you agree to the following terms:</p>

        <h2>1. Account Responsibilities</h2>
        <p>You are responsible for maintaining the confidentiality of your login credentials.</p>

        <h2>2. Service Availability</h2>
        <p>We strive to provide uninterrupted service but do not guarantee 100% uptime.</p>

        <h2>3. Prohibited Activities</h2>
        <ul>
          <li>Unauthorized access attempts</li>
          <li>Misuse of AI-generated responses</li>
          <li>Providing false information</li>
        </ul>

        <h2>4. Payments & Refunds</h2>
        <p>Payments are processed securely. Refunds are subject to our refund policy.</p>

        <h2>5. Termination of Services</h2>
        <p>We reserve the right to suspend accounts violating our policies.</p>

        <hr />
        <h1>Refund Policy</h1>
        <p><strong>Last updated: March 20, 2025</strong></p>
        
        <h2>1. No Automatic Refunds</h2>
        <p>
          At Moon AI, we do not offer automatic refunds for any purchased plans. 
          All payments made for our services are final and non-refundable.
        </p>
        
        <h2>2. Requesting a Refund</h2>
        <p>
          If you believe you have been charged incorrectly or have concerns about our service, 
          you may request a refund review by contacting us through:
        </p>
        <ul>
          <li>Email: <a href="mailto:moon.voice.ai@gmail.com">moon.voice.ai@gmail.com</a></li>
          <li>Our Contact Us section in the home page</li>
        </ul>
        <p>
          Each refund request will be reviewed on a case-by-case basis. 
          We may provide a refund at our sole discretion after evaluating the circumstances.
        </p>
        
        <h2>3. Refund Processing</h2>
        <p>
          If your refund request is approved, it will be processed within <strong>7-10 business days</strong>.
          The refund amount and method will depend on the original payment method used.
        </p>
        
        <h2>4. Contact Us</h2>
        <p>If you have any questions regarding our refund policy, please contact us:</p>
        <p>Email: <a href="mailto:moon.voice.ai@gmail.com">moon.voice.ai@gmail.com</a></p>
        <p>Phone: +91 8851619182</p>
        {/* <p>Adress: Block O, Type V(B), Sector 10, Nivedita Kunj, RK Puram Delhi India, 110022</p> */}
      </div>
    </div>
  );
};

export default LegalPages;
